import React from 'react';
import { StatusIndicator } from 'tuui';
import { TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { TooltipWrapper } from '../../../../../../../components/TooltipWrapper/TooltipWrapper';
import {
    COMMON_FLAGS,
    useCommonConfig,
} from '../../../../../../taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from '../../../../../../taboola-common-frontend-modules/i18n';
import { getStatusIndicatorType } from '../../../../../config';
import { getPacingScoreStatusType } from '../../../../../config/pacingScoreStatusConsts';
import EMPTY_FIELD_VALUE from '../../../config/defaultValues';
import { FormattedNumberCellRenderer } from '../index';
import { usePacingScoreStatus } from './usePacingScoreStatus';
import styles from './pacingScoreStatusCellRenderer.module.scss';

export const PacingScoreStatusCellRenderer = props => {
    const { [COMMON_FLAGS.PACING_SCORE_MIN_VALUE_TO_SHOW]: progressScoreMinValueToShow } = useCommonConfig([
        COMMON_FLAGS.PACING_SCORE_MIN_VALUE_TO_SHOW,
    ]);
    const { value, showEmptyWhenNull = false } = props;
    const { status } = usePacingScoreStatus(value);

    const isValueValid = value != null && value >= progressScoreMinValueToShow;
    const statusType = getPacingScoreStatusType(status);
    const statusIndicatorType = getStatusIndicatorType(statusType);

    return (
        <>
            {isValueValid ? (
                <div className={styles['status-indicator-and-label-container']} aria-label="value">
                    {statusIndicatorType && (
                        <TooltipWrapper
                            tooltipContent={
                                <FormattedMessage id={`app.campaigns.campaignsGroup.pacingScore.tooltip.${status}`} />
                            }
                            tooltipOptions={{ interactive: false, arrow: true, placement: TOOLTIP_POSITION.BOTTOM }}
                        >
                            <StatusIndicator type={statusIndicatorType} className={styles['indicator']} />
                        </TooltipWrapper>
                    )}
                    <FormattedNumberCellRenderer {...props} />
                </div>
            ) : (
                showEmptyWhenNull && EMPTY_FIELD_VALUE
            )}
        </>
    );
};
